export default "__VITE_ASSET__CzhTCM1l__"